<template lang="pug">
    v-form.c-form
        v-container.pt-0(fluid grid-list-lg)
            v-layout.customField(
                v-for="(field, key) in model"
                :key="key"
                raw
                wrap
            )
                v-flex.hidden-sm-and-up(xs12)
                    separator-component.mb-4

                v-flex(xs12 sm4)

                    // Label field (Custom field #1)
                    v-text-field(
                        :error-messages="errors.collect(fieldName(key))"
                        :data-vv-as="$t('fields.fieldTitle')"
                        :label="$t('fields.fieldTitle')"
                        :name="fieldName(key)"
                        v-model="field.label"
                        v-validate="'max:20'"
                        outline
                    )

                v-flex(xs12 sm4)

                    // Field type selection
                    v-select(
                        :items="$t('selection.fieldTypes')"
                        :label="$t('fields.type')"
                        name="`fieldType-${key}`"
                        v-model="field.type"
                        append-icon="expand_more"
                        outline
                    )

                v-flex.pt-2(xs12 sm3 offset-sm1)

                    // Switch (tooggle required field)
                    v-switch.c-switch(
                        :label="field.isRequired ? 'Yes' : 'No'"
                        v-model="field.isRequired"
                        color="action"
                        hide-details
                    )

            v-layout(raw wrap)
                v-flex.hidden-sm-and-up(xs12)
                    separator-component.mb-3

                v-flex(xs12 sm8)

                    info-component(:text="$t('users.create.info')")

        div.conatinerPadder

            // Horizontal line
            separator-component

            div.controls
                div

                    // Cancel button
                    button-component.ml-0.cancel(
                        :action="cancel"
                        :isLoading="isLoading"
                        color="grey"
                        large
                        outline
                    ) {{ $t('defaultButtons.cancel') }}

                div

                    // Submit button
                    button-component.mr-0.submit(
                        :action="createFields"
                        :isLoading="isLoading"
                        color="primary"
                        large
                    )
                        span {{ $t('defaultButtons.download') }}
                        v-icon.iconDownload.ml-1 trending_flat
</template>

<script>
    import Button from '~components/Button';
    import Info from '~components/Info';
    import Separator from '~components/Separator';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            InfoComponent: Info,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapFields('document', {
                model: 'fields'
            }),
            ...mapGetters('document', ['isLoading'])
        },
        created() {
            this.readFields();
        },
        methods: {
            ...mapActions('document', ['createFields', 'readFields', 'cancel']),

            /**
             * Generate field name
             * @param {number} key
             * @returns {string}
             */
            fieldName(key) {
                return `fieldTitle-${ key }`;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .c-form
        justify-content: space-between

    .iconDownload
        transform: rotate(90deg)
        font-size: 18px
</style>
